import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';

import Navbar from "./Components/NavBarComponents/Navbar.jsx";
import ScrollToTop from "./Components/NavBarComponents/ScrollToTop.jsx";
import HomePage from "./Components/HomeComponents/HomePage.jsx";
import Contact from "./Components/ContactUsComponents/Contact.jsx";
import Portal from "./Components/PortalComponents/Portal.jsx";
import AboutUsPage from "./Components/AboutusComponents/AboutUsPage.jsx";
import RoutesPage from "./Components/RoutesComponents/RoutesPage.jsx";
import SubscriptionPage from "./Components/subscriptionComponents/SubscriptionPage.jsx";
import Footer from "./Components/FooterComponents/Footer.jsx";
import PrivacyPolicyPage from "./Components/PrivacyTermsComponents/PrivacyPolicyPage.jsx";
import TermsOfServicePage from "./Components/PrivacyTermsComponents/TermsOfServicePage.jsx";





function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="staffline-app">
        <Navbar />

        <main className="staffline-main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/portal" element={<Portal/>} />
            <Route path="/about-us" element={<AboutUsPage/>} />
            <Route path="/routes" element={<RoutesPage/>} />
            <Route path="/subscription" element={<SubscriptionPage/>} />
            <Route path="/privacy" element={<PrivacyPolicyPage/>} />
            <Route path="/terms" element={<TermsOfServicePage/>} />
            
          </Routes>
        </main>

        <Footer/>

      </div>
    </Router>
  );
}

export default App;
